import { render, staticRenderFns } from "./EmailComplianceModal.vue?vue&type=template&id=a72fa638&scoped=true"
import script from "./EmailComplianceModal.vue?vue&type=script&lang=js"
export * from "./EmailComplianceModal.vue?vue&type=script&lang=js"
import style0 from "./EmailComplianceModal.vue?vue&type=style&index=0&id=a72fa638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72fa638",
  null
  
)

export default component.exports